import { TABLE } from 'shared/lib/core/constants';
import {
	HallmapResources,
	HallmapTable,
	LayoutItem,
	ResourceType,
} from '../../../model/types';

export const mapResourcesHallmap = ({
	resources,
	resourceTypes,
	layoutItems,
}: HallmapResources) => {
	if (
		!resources ||
		!resources.length ||
		!resourceTypes ||
		!resourceTypes.length ||
		!layoutItems ||
		!layoutItems.length
	) {
		return false;
	}

	const layoutItemsMap = new Map();
	layoutItems.map(item => {
		layoutItemsMap.set(item.resource, item);
	});

	const resourceTypesMap = new Map();
	resourceTypes.map(type => {
		resourceTypesMap.set(type.id, type);
	});

	const hallmapTables: HallmapTable[] = [];
	resources.map(resource => {
		const layoutItem: LayoutItem = layoutItemsMap.get(resource.id);

    if (!layoutItem) return;

		let config = layoutItem?.config;
		if (config && !config.x && !config.y) {
			config = null;
		}

		const resourceType = {...resourceTypesMap.get(resource.resource_type) || {} as ResourceType};

		if (resourceType.form === 'square') {
			resourceType.form = TABLE.FORMS.QUAD;
		}

		if (resourceType.form === 'rect' || resourceType.form === 'recth' || resourceType.form === 'rectv') {
			resourceType.form = TABLE.FORMS.RECT;
		}

		const hallmapTable: HallmapTable = {
			resourceType,
			resource,
			config,
			layout: layoutItem,
		};

		hallmapTables.push(hallmapTable);
	});


	return hallmapTables;
};
